export class EvaluationsMessages {
    public static readonly REVIEW_CYCLE_DETAILS = 'evaluations.review-cycle-details';
}